import { persistUTMQueryParamsToString } from "@common/utils/router";
import { Anchor } from "@mantine/core";
import Link from "next/link";
import { ReactElement } from "react";
import { ISettingsLinkProps } from "./types";
import { useRouter } from "next/router";

export default function SettingsLink({
  purchaseId,
}: ISettingsLinkProps): ReactElement {
  const router = useRouter();

  return (
    <Anchor
      component={Link}
      href={persistUTMQueryParamsToString(
        router,
        `/account/${purchaseId}/settings`,
      )}
      fz="sm"
      fw={700}
    >
      Settings
    </Anchor>
  );
}
